export default "__VITE_ASSET__BdzmiKLS__"